import React, { useEffect, useState } from "react";
import { BsCurrencyDollar } from "react-icons/bs";
import { IoIosMore } from "react-icons/io";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";

import { Stacked, Pie, Button, LineChart, SparkLine } from "../components";
import {
  earningData,
  medicalproBranding,
  recentTransactions,
  weeklyStats,
  dropdownData,
  SparklineAreaData,
  ecomPieChartData,
} from "../data/dummy";
import { useStateContext } from "../contexts/ContextProvider";
import product9 from "../data/product9.jpg";
import axios from "axios";
import { baseUrl } from "../data/baseURL";
import { MdOutlineSupervisorAccount } from "react-icons/md";

const DropDown = ({ currentMode }) => (
  <div className="w-28 border-1 border-color px-2 py-1 rounded-md">
    <DropDownListComponent
      id="time"
      fields={{ text: "Time", value: "Id" }}
      style={{ border: "none", color: currentMode === "Dark" && "white" }}
      value="1"
      dataSource={dropdownData}
      popupHeight="220px"
      popupWidth="120px"
    />
  </div>
);

const Ecommerce = () => {
  const { currentColor, currentMode } = useStateContext();
  const [statistic, setStatistic] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}/Forms/GetFormStats`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setStatistic(Object.values(response.data.data));
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };

    fetchData();
  }, []);
  const [chart, setChart] = useState();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(`${baseUrl}/Forms/GetFillStats`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setChart(response.data.data);
      } catch (error) {
        console.error("Error fetching data from API", error);
      }
    };

    fetchData();
  }, []);
  return (
    <div className="w-full flex flex-col justify-center items-center gap-10 pl-10">
      <div className="flex flex-wrap lg:flex-nowrap justify-center w-full p-5">
        <div className="flex m-3 flex-wrap justify-between items-center w-full gap-3">
          {statistic?.map((item, index) => (
            <div
              key={item}
              className="bg-white border h-40 dark:text-gray-200 dark:bg-secondary-dark-bg md:w-56  p-4 !w-[250px]  rounded-2xl "
              style={{
                backgroundColor: currentColor,
              }}
            >
              <button
                type="button"
                style={{ color: "#03C9D7", backgroundColor: "#E5FAFB" }}
                className="text-2xl opacity-0.9 rounded-full  p-4 hover:drop-shadow-xl"
              >
                <MdOutlineSupervisorAccount />
              </button>
              <p className="mt-3">
                <span className="text-lg font-semibold">{item}</span>
              </p>
              <p className="text-sm text-gray-900  mt-1">
                {index === 0
                  ? "فرم خادمی"
                  : index === 1
                  ? "فرم پای کار حسین"
                  : index === 2
                  ? "فرم میزبانی"
                  : "فرم باشگاه اربعینی"}
              </p>
            </div>
          ))}
        </div>
      </div>

      <div className="flex gap-10 flex-wrap justify-center w-full">
        <div className="w-full px-10">
          <div
            className=" rounded-2xl p-4 border"
            style={{ backgroundColor: "white" }}
          >
            <div className="flex justify-between items-center ">
              <p className="font-semibold text-black text-2xl">
                فرم های پرشده طی ۱۴ روز گذشته
              </p>
            </div>

            {chart && (
              <div className="mt-6">
                <SparkLine
                  currentColor={currentColor}
                  id="column-sparkLine"
                  height="250px"
                  type="Column"
                  data={[
                    { x: 1, yval: chart[0] },
                    { x: 2, yval: chart[1] },
                    { x: 3, yval: chart[2] },
                    { x: 4, yval: chart[3] },
                    { x: 5, yval: chart[4] },
                    { x: 6, yval: chart[5] },
                    { x: 7, yval: chart[6] },
                    { x: 8, yval: chart[7] },
                    { x: 9, yval: chart[8] },
                    { x: 10, yval: chart[9] },
                    { x: 11, yval: chart[10] },
                    { x: 12, yval: chart[11] },
                    { x: 13, yval: chart[12] },
                    { x: 14, yval: chart[13] },
                  ]}
                  width="100%"
                  color={currentColor}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Ecommerce;
